import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            return 'har-ejeren-anmeldt-skaden';
        case 'har-ejeren-anmeldt-skaden':
            nextPage = 'om-ejeren';
            break;
        case 'om-ejeren':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'var-du-sammen-med-ejeren';
            break;
        case 'var-du-sammen-med-ejeren':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'hvad-er-skadet';
            break;
        case 'hvad-er-skadet':
            nextPage = 'laant-eller-lejet';
            break;
        case 'laant-eller-lejet':
            nextPage = 'skadevolder';
            break;
        case 'skadevolder':
            const skadeVolderValue = getValueOrDefault(formConfig, formValues, 'hvemforrsagedeskaden').value;
            if (skadeVolderValue === 'Min hund') {
                nextPage = 'om-hunden';
            } else {
                nextPage = 'alder';
            }
            break;
        case 'alder':
            nextPage = 'om-koeretoej';
            break;
        case 'om-hunden':
            nextPage = 'blev-hunden-passet';
            break;
        case 'blev-hunden-passet':
            const hundPassetValue = getValueOrDefault(
                formConfig,
                formValues,
                'blevdinhundpassetafejerenafdetdelagte'
            ).value;
            if (hundPassetValue === 'Ja') {
                nextPage = 'pasningstidspunkt';
            } else {
                nextPage = 'om-ansvar';
            }
            break;
        case 'pasningstidspunkt':
            nextPage = 'om-ansvar';
            break;
        case 'om-koeretoej':
            const damageKoeretoj = getValueOrDefault(
                formConfig,
                formValues,
                'erskadenbegetmedetkretjellerenmotoriseretgenstand'
            ).value;
            if (damageKoeretoj === 'Ja') {
                nextPage = 'om-koeretoej-eller-genstand';
            } else if (damageKoeretoj === 'Andet') {
                nextPage = 'beskriv-koeretoej-eller-genstand';
            } else {
                nextPage = 'om-ansvar';
            }
            break;
        case 'om-koeretoej-eller-genstand':
            nextPage = 'om-ansvar';
            break;
        case 'beskriv-koeretoej-eller-genstand':
            nextPage = 'om-ansvar';
            break;
        case 'om-ansvar':
            nextPage = 'politianmeldelse';
            break;
        case 'politianmeldelse':
            const politiAnmeldelse = getValueOrDefault(formConfig, formValues, 'policeContacted').value;
            if (politiAnmeldelse === 'Ja') {
                nextPage = 'om-anmeldelsen';
            } else {
                nextPage = 'dokumentation';
            }
            break;

        case 'om-anmeldelsen':
            nextPage = 'samtykke';
            break;
        case 'samtykke':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'andet-selskab';
            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'i-hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'i-hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
